if(typeof bufferutil === 'undefined') {var e = new Error("Cannot find module \"bufferutil\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = bufferutil;


//////////////////
// WEBPACK FOOTER
// external "bufferutil"
// module id = 383
// module chunks = 0